import type { DynamicDialogConfig } from '../exports/primeng';

export function buildDialogConfig<TData = unknown>(
  config: DynamicDialogConfig<TData>,
): DynamicDialogConfig<TData> {
  return {
    modal: true,
    dismissableMask: true,
    closeOnEscape: true,
    showHeader: false,
    closable: true,
    breakpoints: { '960px': '95vw' },
    ...config,
  };
}

export function buildSettingsDialogConfig<TData = unknown>(
  config: DynamicDialogConfig<TData>,
): DynamicDialogConfig<TData> {
  return buildDialogConfig({
    styleClass: 'add-edit-dialog',
    ...config,
  });
}

export function buildScrollableDialogConfig<TData = unknown>(
  config: DynamicDialogConfig<TData>,
): DynamicDialogConfig<TData> {
  return buildDialogConfig({
    contentStyle: { overflow: 'auto', maxHeight: '85vh' },
    breakpoints: { '960px': '96vw' },
    ...config,
  });
}

export function buildProductionBatchDialogConfig<TData = unknown>(
  config: DynamicDialogConfig<TData>,
): DynamicDialogConfig<TData> {
  return buildScrollableDialogConfig({
    width: '72rem',
    ...config,
  });
}

export function buildSettingsFormDialogConfig<TData = unknown>(
  config: DynamicDialogConfig<TData>,
): DynamicDialogConfig<TData> {
  return buildSettingsDialogConfig({
    height: 'content-fit',
    ...config,
  });
}
